/// <reference types="@types/requestidlecallback" />
/* global window:readonly */

/**
 * @fileoverview polyfill and façade for requestIdleCallback
 * @note this was heavily lifted from https://github.com/pladaria/requestidlecallback-polyfill/blob/master/index.js
 *   Not going to add this to package.json for something this trivially small or overwrite window methods
 */

type IdleCallbackArg = {
  didTimeout: boolean;
  timeRemaining: () => number;
};

export const requestIdleCallback = (cb: (arg: IdleCallbackArg) => void): NodeJS.Timeout => {
  if (window.requestIdleCallback) {
    return window.requestIdleCallback(cb) as unknown as NodeJS.Timeout;
  }
  const start = Date.now();
  return setTimeout(() => {
    cb({
      didTimeout: false,
      timeRemaining: () => {
        return Math.max(0, 50 - (Date.now() - start));
      },
    });
  }, 1);
};

export const cancelIdleCallback = (id: number) => {
  if (window.cancelIdleCallback) {
    window.cancelIdleCallback(id);
  } else {
    clearTimeout(id);
  }
};
